import { DateTime } from 'scaleflow/utils/date-time';

/** `(now)` — the current time, for passing to `format-date`. */
export default function now(): DateTime {
  return DateTime.now();
}
